import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TextInput,
  CreateButton,
  TopToolbar,
  usePermissions,
} from "react-admin";

const WayOfArrivalFilter = [
  <TextInput source="_q" label="Search" alwaysOn variant="outlined" />,
];

const WayOfArrivalActions = () => {
  const { permissions } = usePermissions();
  return (
    <TopToolbar>
      {permissions === "Admin" ? <CreateButton /> : null}
    </TopToolbar>
  );
};

export const WayOfArrivalList = () => {
  const { permissions } = usePermissions();

  return (
    <List filters={WayOfArrivalFilter} actions={<WayOfArrivalActions />} exporter={false}>
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="value" label="Value" />
        {permissions === "Admin" ? <EditButton /> : ""}
      </Datagrid>
    </List>
  );
};
